import React, {useState} from 'react';
import { OverlayTrigger, Tooltip } from "react-bootstrap";


const CustomDataViewerCheckBox = ({ cell }) => {

    return (
        cell === undefined || cell === null ? <div/> :
        Object.keys(cell).includes('tooltip') && cell.tooltip !== '' && 
            cell.tooltip !== null && cell.tooltip !== undefined ? 
            <OverlayTrigger
                placement="top"
                overlay={<Tooltip id={`tooltip-${cell.row}-${cell.column}`}>{cell.tooltip}</Tooltip>}>
                <div className="excel-table-cell">
                <input className='checkbox-custom' type="checkbox" onChange={()=> cell.onChange()}
                    checked={cell.checked}/>
                </div>
            </OverlayTrigger> 
            : <div style={{ cursor: "pointer" }} 
            className={cell.className + ' excel-table-cell'}>
            <input className='checkbox-custom' type="checkbox" onChange={()=> cell.onChange()}
                checked={cell.checked}/>
            </div>
    );
};

export default CustomDataViewerCheckBox;